import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state() {
    return {
      dossiersList: [],
      personList: [],
      person: {},
      dossier: null,
      dossierMetadata: {},
      editionMode: false,
      leaveRouteByButton: false,
      leaveRouteByNotification: false,
      initialDossier: null,
      hasChanged: true,
      navSubItems: [],
      partnerData: {},
      partnerSharing: {},
      partnerSharingErrors: {},
      online_members: [],
      statusSummary: null
    }
  },
  getters: {
    ...getters
  },
  actions,
  mutations: {
    ...mutations
  }
}
